import React from 'react';

export const DefaultBox = ({ className, children }) => {
    return <div className={`default-box ${className}`}>{children}</div>;
};
export const BoxHeader = ({ className, title, icon }) => {
    return (
        <div className={`  ${className}`}>
            <div className="box-header">
            <div className="box-header-img">
                    <img src={icon} alt={title} />
                </div>
                <h6 className="box-header-title">{title}</h6>
                
            </div>
        </div>
    );
};
